module.exports = __webpack_public_path__ + "static/American-Flag-Enhanced-067e8b700c5b59ef6533f61923022438.svg";